class RevenueGrowthAudit extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.error = this.querySelector('[data-audit-error]');
    this.website = this.querySelector('[data-audit-website]');
    this.channels = this.querySelector('[data-audit-channels]');
    this.preselectInterest();
    this.form.addEventListener('submit', (event) => this.submit(event));
  }

  preselectInterest() {
    const allowed = {
      'growth-foundation': 'Growth Foundation',
      'revenue-system-build': 'Revenue System Build',
      enterprise: 'Enterprise'
    };
    const requested = new URLSearchParams(window.location.search).get('interest');
    const select = this.querySelector('[data-audit-interest]');
    if (select && allowed[requested]) select.value = allowed[requested];
  }

  normalizeWebsite() {
    const value = this.website.value.trim();
    if (value && !/^https?:\/\//i.test(value)) this.website.value = `https://${value}`;
  }

  setChannels() {
    const selected = [...this.querySelectorAll('[data-audit-channel]:checked')].map((input) => input.value);
    this.channels.value = selected.join(', ');
  }

  showError(message) {
    this.error.textContent = message;
    this.error.classList.add('is-visible');
    this.error.focus();
  }

  async submit(event) {
    this.normalizeWebsite();
    this.setChannels();
    if (!this.form.checkValidity()) {
      event.preventDefault();
      this.form.reportValidity();
      this.showError('Please complete all required fields before continuing.');
      return;
    }
    event.preventDefault();
    this.error.classList.remove('is-visible');
    const button = this.form.querySelector('[type="submit"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.form)
      });
      if (!response.ok) throw new Error('add_failed');
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'audit_checkout_started',
          audit_product: 'revenue-growth-audit'
        });
      }
      window.location.assign(`${window.Shopify.routes.root}checkout`);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      this.showError('We could not start checkout. Please try again. Your information is still in the form.');
    }
  }
}
customElements.define('revenue-growth-audit', RevenueGrowthAudit);
